import React, { Component } from 'react'
import { connect } from 'react-redux'

import Snackbar from 'material-ui/Snackbar'

import dataActions from 'actions/dataActions'

let select = (state) => ({
	error: state.error
})

export class prompt extends Component{
	render(){
		let { props } = this
		return(
			<Snackbar
	          open={!!props.error}
	          message={props.error}
	          autoHideDuration={4000}
	        />
		)
	}
}

export default connect(select)(prompt)



// WEBPACK FOOTER //
// ./src/components/ErrorSnackbar.js